import React from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import './MobileBottomNav.scss';
import {
  FilterAnomaly,
  FilterKAI,
  IconAccruals,
  IconAsk,
  IconChartDashboard,
  IconDashboard,
  IconDashboardNew,
} from 'components/Icons';
import { prefixClass } from 'lib/utils';

type Props = {
  activeTab: 'home' | 'requests' | 'kai';
  onTabChange: (tab: 'home' | 'requests' | 'kai') => void;
};

type NavItemProps = {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
  isDisabled?: boolean;
  prefix: (className: string) => string;
};

const MobileBottomNavItem: React.FC<NavItemProps> = ({ icon, label, isActive, onClick, isDisabled, prefix }) => {
  return (
    <div
      onClick={!isDisabled ? onClick : undefined}
      className={classNames(prefix('item'), {
        active: isActive,
        disabled: isDisabled,
      })}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-disabled={isDisabled}
    >
      <div className={prefix('item-icon')}>{icon}</div>
      <div className={prefix('item-label')}>{label}</div>
    </div>
  );
};

function MobileBottomNav({ activeTab, onTabChange }: Props): JSX.Element {
  const { locationId } = useParams();
  const prefix = prefixClass('MobileBottomNav');

  return (
    <div className={prefix()}>
      <MobileBottomNavItem
        icon={<IconDashboardNew />}
        label="Home"
        isActive={activeTab === 'home'}
        onClick={() => onTabChange('home')}
        prefix={prefix}
      />
      <MobileBottomNavItem
        icon={<IconAsk />}
        label="Queue"
        isActive={activeTab === 'requests'}
        onClick={() => onTabChange('requests')}
        prefix={prefix}
      />
      <MobileBottomNavItem
        icon={<FilterKAI />}
        label="KAI"
        isActive={activeTab === 'kai'}
        onClick={() => onTabChange('kai')}
        prefix={prefix}
      />
    </div>
  );
}

export default MobileBottomNav;
